import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@shared/hooks/index.ts';
import { usePublicate } from 'library/hooks/events';
import type { Event } from 'library/models/events';
import { openModerationModal } from 'library/redux/modal';
import { useAppDispatch } from '../common';

type Props = {
  event: Event | null;
  isAuthor?: boolean;
};

const useModeration = ({ event, isAuthor }: Props) => {
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const { publicate } = usePublicate();
  const navigate = useNavigate();

  const showModeration = (): boolean => {
    return event?.author?.id === user?.id;
  };
  const publicateEvent = () => {
    event?.id && publicate(event.id);
  };

  const editEvent = () => {
    event && navigate(`/events/${event.id}/edit`);
  };

  useEffect(() => {
    if (isAuthor && event?.moderation_status.abbr_status === 'D') {
      showModerationText();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event?.id]);

  const showModerationText = () => {
    dispatch(
      openModerationModal({
        title: 'Модерация не пройдена',
        text: 'Внести изменения в мероприятия?',
        confirmText: 'Да',
        confirm: () => editEvent(),
        declineText: 'Нет',
        statusText: event?.moderation_status?.comment,
      })
    );
  };

  // const showModerationStatus = () => {
  //   dispatch(
  //     openNotifyModal({
  //       title: 'Модерация',
  //       text: 'Осталось немного подождать. Наши специалисты проверяют программу',
  //       confirmText: 'Ок',
  //     })
  //   );
  // };

  const getModerationClass = () => {
    return !event?.published
      ? 'unpublished'
      : event?.moderation_status && event.moderation_status.abbr_status === 'N'
        ? 'moderation'
        : event?.moderation_status && event.moderation_status.abbr_status === 'D'
          ? 'failed'
          : '';
  };

  return {
    showModeration: showModeration(),
    publicateEvent,
    getModerationClass,
    // showModerationStatus,
    showModerationText,
  };
};

export default useModeration;
